module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sextans/sex_gal-40bbfd3fee63a746635aaf4e1af6e8c6.gif";